import React, { FC, useMemo } from "react";
import { useIntl } from "react-intl";
import noop from "lodash/fp/noop";
import debounce from "lodash/debounce";
import X2yForm from "../X2yForm";
import useLeftAndRightLists from "../listHooks/useLeftAndRightLists";
import { optionDataToRSSI } from "../utils";
import { X2yController } from "../../../../store/x2y/types";
import { OptionListData } from "../types";
import { useBasicReduxHoox } from "./useReduxHoox";

const X2yBasic: FC<Props> = ({
  xIdOrIds,
  onSaveCallback = noop,
  multiList,
  controller,
  disableSearch = false,
  listSize,
  placeholder,
}) => {
  const { useData, useSubmit } = useBasicReduxHoox(controller);

  const { formatMessage } = useIntl();

  const { isReady, unselected, selected, ysById, isFetching, isSubmitting } =
    useData(xIdOrIds);

  const submit = useSubmit();

  // Zajištění kontinuálních referencí napříč rendery - jinak se to dojebe!
  const selectedStr = useMemo(() => selected.map(String), [selected]);
  const unselectedStr = useMemo(() => unselected.map(String), [unselected]);

  const { leftList, rightList, moveLeft, moveRight } = useLeftAndRightLists({
    headerLeft: formatMessage({ id: "x2y.table_data.unselected" }),
    headerRight: formatMessage({ id: "x2y.table_data.selected" }),
    allOptionsById: ysById,
    initialIdsLeft: unselectedStr,
    initialIdsRight: selectedStr,
    searchEnabled: !disableSearch,
    listSize,
  });

  const onSave = async () => {
    const payload = {
      selected: rightList.options.map(optionDataToRSSI),
      unselected: leftList.options.map(optionDataToRSSI),
    };
    const saveCallback = debounce(() => onSaveCallback(), 100);

    await submit(xIdOrIds, payload);
    saveCallback();
  };

  return (
    <X2yForm
      leftList={leftList}
      rightList={rightList}
      multiList={multiList}
      moveLeft={moveLeft}
      moveRight={moveRight}
      onSave={onSave}
      isFetching={isFetching}
      isSubmitting={isSubmitting}
      isLoading={!isReady}
      placeholder={placeholder}
    />
  );
};

export type Props = {
  xIdOrIds: number | number[];
  onSaveCallback?: () => void;
  multiList?: OptionListData;
  controller: X2yController;
  disableSearch?: boolean;
  listSize?: number;
  placeholder?: string;
};

export default X2yBasic;
export type X2yBasicProps = Props;
